import React, { useState, useRef, useEffect } from "react";
import "react-dropdown/style.css";
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { AddGoiVayBtn } from "./AddGoiVayBtn";
import dsGoiVayApi from "../../../service/GoiVay/dsGoiVayApi";
import StoreApi from "../../../service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";
import CauHinhApi from "../../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";

export const DanhSachGoiVay = () => {
  const dispatch = useDispatch();
  const [dataDanhSach, setDataDanhSach] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchGoiVay);
  const [isCauHinhQuyTrinhPheDuyet, setIsCauHinhQuyTrinhPheDuyet] =
    useState(false);
  const [isCauHinhT86, setIsCauHinhT86] = useState(false);

  const initPhanQuyen = {
    quytrinhpheduyet_danhsach: false,
    quytrinhpheduyet_cappheduyet: false,
    quytrinhpheduyet_cauhinhchoduyet: false,
    quytrinhpheduyet_quanlygoivay: false,
    quanlygoivay: false,
    quanlygoivay_themmoigoivay: false,
    quanlygoivay_suagoivay: false,
    quanlygoivay_xoagoivay: false,
  };

  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  useEffect(() => {
    document.title = "Danh sách gói vay | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    onSearch();
  }, []);
  const onSearch = () => {
    dsGoiVayApi
      .list({
        sSearch: dataSearch.sSearch,
        iPageSize: dataSearch.iPageSize,
        iPageIndex: dataSearch.iPageIndex,
      })
      .then((response) => {
        if (response.status == "200") {
          setDataDanhSach(response.data);
        }
      });
  };
  const LoadPhanQuyen = () => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isCauHinhPheDuyet = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQuyTrinhPheDuyet.toUpperCase()
          );
          console.log("isCauHinhPheDuyet", isCauHinhPheDuyet);

          if (isCauHinhPheDuyet != null) {
            if (isCauHinhPheDuyet.valueConfig === "1") {
              setIsCauHinhQuyTrinhPheDuyet(true);
              loadPhanQuyenTheoCauHinh(true);
            } else {
              loadPhanQuyenTheoCauHinh(false);
            }
          }

          const isCauHinhT86 = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsCauHinhT86.toUpperCase()
          );
          if (isCauHinhT86 != null) {
            if (isCauHinhT86.valueConfig === "1") {
              console.log("isCauHinhT86", isCauHinhT86);
              setIsCauHinhT86(true);
            }
          }

          loadPhanQuyenTheoCauHinh(false);
        }
      }
    });

    const loadPhanQuyenTheoCauHinh = (IsPheDuyet) => {
      if (IsPheDuyet) {
        StoreApi.phanQuyenQuyTrinhPheDuyet().then((response) => {
          setPhanQuyen({
            ...phanQuyen,
            quytrinhpheduyet_danhsach: response.data.quytrinhpheduyet_danhsach,
            quytrinhpheduyet_cappheduyet:
              response.data.quytrinhpheduyet_cappheduyet,
            quytrinhpheduyet_cauhinhchoduyet:
              response.data.quytrinhpheduyet_cauhinhchoduyet,
            quytrinhpheduyet_quanlygoivay:
              response.data.quytrinhpheduyet_quanlygoivay,
          });
        });
      } else {
        StoreApi.phanQuyenGoiVay().then((response) => {
          setPhanQuyen({
            ...phanQuyen,
            quanlygoivay: response.data.quanlygoivay,
            quanlygoivay_themmoigoivay:
              response.data.quanlygoivay_themmoigoivay,
            quanlygoivay_suagoivay: response.data.quanlygoivay_suagoivay,
            quanlygoivay_xoagoivay: response.data.quanlygoivay_xoagoivay,
          });
        });
        console.log("phanQuyen", phanQuyen);
      }
    };
  };
  return (
    <LayoutV2>
      {(phanQuyen.quytrinhpheduyet_quanlygoivay || isCauHinhT86) && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Danh sách gói vay</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop onSearch={onSearch} />
                  </div>
                </div>
              </div>
              <SearchBarMobile onSearch={onSearch} />
              <AddGoiVayBtn data={""} onSearch={onSearch} />
            </div>
          </div>
          <TableDanhSach
            dataDanhSach={dataDanhSach}
            onSearch={onSearch}
            phanQuyen={phanQuyen}
          />
        </div>
      )}
      {!(phanQuyen.quytrinhpheduyet_quanlygoivay || isCauHinhT86) && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <Headersubfull
                  title="Danh sách gói vay"
                  icon1="fas fa-donate"
                />
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
